import { render } from "./MagnificPopUp.vue?vue&type=template&id=d804db82"
import script from "./MagnificPopUp.vue?vue&type=script&lang=js"
export * from "./MagnificPopUp.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src3987420887/src/bt-website-2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__